import { Component, Input, OnInit, ViewChild, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';

import { Navigator } from 'src/app/services/routing/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { isUndefined } from 'src/app/services/codeUtils';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { first } from 'rxjs';
import { Browser } from '@capacitor/browser';
//import { BankConnectAuth } from 'capacitor-plugin-vipconnect';

declare var window: any;

@Component({
  selector: 'app-deposit-vip-widget-main',
  templateUrl: './deposit-vip-widget-main.component.html',
  styleUrls: ['./deposit-vip-widget-main.component.scss'],
})
export class DepositVIPWidgetMainComponent extends CashierBase implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public navigateBackPage: any;

  public allowDesktop: boolean;
  public newWindow: any;
  public bonusCode: string;
  public braintreeToken: any;
  public customer: any;
  public loading: any;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public minAmount: any;
  public paymentType: any = [];
  public paymentRequestID: any;
  public vendorLogoUrl: string = '';
  public buttonDisabled: boolean = false;
  private depositTimeout: any;
  private exceededDepositLimit: boolean = false;
  private isIabClosed: boolean = false;

  public depositForm: FormGroup;
  public amount: AbstractControl;
  public storeAmount;
  vipWidgetURL: any;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform,
    public UserSessionService: UserSessionService,
    public successMessageService: SuccessMessageService,
    private iab: InAppBrowser,
    @Inject('IOS_WEB_AUTH_SESSION') private webAuthSession: any
  ) {
    super();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.getCustomer();
  }

  ngOnInit() {
    this.vipWidgetURL = this.config.getConfig().FEATURE_VIP_DEPOSIT_WIDGET_URL;
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);

    this.depositForm = new FormGroup({
      amount: new FormControl({ value: '', disabled: false }, { validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change' }),
    });

    this.amount = this.depositForm.get("amount");
    
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('vippreferred').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('PV').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        if (!isUndefined(this.paymentType)) {
          this.minAmount = this.paymentType[0].min;
          this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
        }
      }
    }, (error) => console.log("Type category error", error));

    this.isIabClosed = false;
    this.events.subscribe('event:deposit', (data) => {
      if (data?.paymentMethod === 'PV') {
        clearTimeout(this.depositTimeout);
        this.checkDepositApproved();
      }
    });

    this.events.subscribe('event:deposit:failed', (e) => {
      clearTimeout(this.depositTimeout);
      this.buttonDisabled = false;
      this.checkDepositFailed(e);
    });

  }

  public checkDepositApproved() {
    this.loading?.dismiss();
    this.closeiAB();
    if (this.exceededDepositLimit) return this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.depositForm.get('amount').value, customerId: this.cashierService.customer.customerId });
    return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { amount: this.depositForm.get('amount').value, status: true, message: 'Your balance will be updated shortly.' });
  }

  public checkDepositFailed(e: any) {
    this.loading?.dismiss();
    this.closeiAB();
    let message = e.text;
    if (e.customField6 == 'TEST_ACCOUNT_MAX_FUNDS_REACHED') message = 'Cannot deposit more than 999 on test account.';
    if (e.customField6 == 'OVER_DEPOSIT_LIMIT') message = 'You have exceeded your maximum deposit limit'; // error message will show in modal
    return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { amount: this.depositForm.get('amount').value, status: false, message: message });
  }

  private closeiAB() {
    if(!this.isIabClosed) {
      const iabCloseTimeout = Number(this.config.getConfig().FEATURE_VIP_DEPOSIT_IAB_CLOSE_TIMEOUT) || 3000;
      setTimeout(() => {
        if (this.isAndroidApp() && Browser) {
          Browser.removeAllListeners();
        } else if(this.isIosApp() && this.webAuthSession) {
          this.webAuthSession.cancelSession();
        }
      }, iabCloseTimeout);
      this.isIabClosed = true;
    }
  }

  private getCustomer() {
    this.UserSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        this.customer = customer;
      });
    });
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  private checkDepositStatus(paymentRequestID) {
    this.depositService
          .checkDepositStatus(paymentRequestID)
          .pipe(first())
          .subscribe((response) => {
            if (!isUndefined(response.payload)) {
              switch (response.payload.status) {
                case "APPROVED":
                  this.checkDepositApproved();
                  break;
                default:
                  this.checkDepositFailed(response.payload);
                  break;
              }
            }
          });
  }

  private isAndroidApp() {
    return this.platform.is("capacitor") && this.platform.is("android");
  }

  private isIosApp() {
    return this.platform.is("capacitor") && this.platform.is("ios");
  }

  isMobileApp() {
    return this.platform.is("capacitor");
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.error = null;
    this.successMessageService.clearMessage();


    let depositFormObj: any = this.depositForm.value;
    const amount = this.depositForm.get('amount').value;
    depositFormObj.amount = amount;
    depositFormObj.payment_type_code = 'PV';
    depositFormObj.currency_code = this.customer.preferredCurrency.currencyCode;
    if (this.bonusCode != "") depositFormObj.bonusCode = this.bonusCode;

    this.cashierService.callDeposit(depositFormObj).subscribe((response: any) => {
      setTimeout(() => {
        this.buttonDisabled = false;
      }, 1500);

      this.storeAmount = this.depositForm.get('amount').value;
      this.depositForm.get('amount').patchValue('');
      this.depositForm.get('amount').markAsPristine();

      if (!isUndefined(response) && !!response.result) {
        this.paymentRequestID = response.payload.paymentRequestID;
        let sessionId = response.payload.parameters.sessionId;

        // Added to show threshold popup when amound of deposits cross the threshold limit. STRDSTUSA-1591
        this.exceededDepositLimit = false;

        if (response.payload) {
          if ('hasExceededDepositLimit' in response.payload) {
            this.exceededDepositLimit = response.payload.hasExceededDepositLimit;
          }
        }

        if (!this.isMobileApp()) {
          let w: any = window;
          this.newWindow = w.open("about:blank", "_system");
          this.newWindow.document.write(
            "<style> body{ background:var(--ion-color-secondary);!important;  position: relative;} div.container { margin: 0;position: absolute;top: 50%;left: 50%;-ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);color: white;font-family: roboto;font-size: 1.5em; }</style>"
          );
          this.newWindow.document.write(
            "<body><div class='container'>LOADING...</div></body>"
          );
        }

        let paymentRequestID = response.payload.paymentRequestID;
        this.navigator.dismissAll();

        //TODO Add this URL to config
        let vipWidgetUrl = this.vipWidgetURL ? this.vipWidgetURL + sessionId : undefined;

        if (this.isMobileApp() && vipWidgetUrl) {
          return this.handleMobileView(vipWidgetUrl, paymentRequestID)
        } else {
          this.newWindow.location = vipWidgetUrl;
          this.buttonDisabled = false;

          
          return this.newWindow.focus();
        }
      }
    }, error => {
      this.buttonDisabled = false;
      this.error = this.handleError(error);
      this.content.scrollToTop();
      this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: false, message: this.error.error_message });
    });
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }
  
  private async handleMobileView(vipWidgetUrl, paymentRequestID) {
    if(this.isAndroidApp()) {  
      await Browser.open({
        url: vipWidgetUrl
      });
      Browser.addListener('browserFinished', () => {
        console.log("Session completed");
        this.onIABCloseManually(paymentRequestID);
        Browser.removeAllListeners();
      });
    } else if(this.isIosApp()) {
      this.webAuthSession.startSession({
        urlString: vipWidgetUrl,
        returnUrlScheme: 'mohegansunnj-play'
      }).then(result => {
        console.log("Session completed", result);
        this.onIABCloseManually(paymentRequestID);
      })
      .catch(error => {
        console.error("Session failed", error);
        this.onIABCloseManually(paymentRequestID);
      });
    }
    this.buttonDisabled = false;
  }

  private onIABCloseManually(paymentRequestID) {
    if(!this.isIabClosed) {
      this.isIabClosed = true;
      this.checkDepositStatus(paymentRequestID);
    }
  }
}
